import StudentLayout from '@/components/template/StudentLayout';
import { StudentDashboardProvider } from '@/data/context/StudentDashboardContext';
import useSearchParamCourseProgressSelection from '@/data/hook/course-progress/useSearchParamCourseProgressSelection';
import useAuth from '@/data/hook/useAuth';
import StudentContinuitySection from './student/StudentContinuitySection';
import StudentCourseTrackSection from './student/StudentCourseTrackSection';
import StudentDashboardHeaderSection from './student/StudentDashboardHeaderSection';
import StudentShortcutsSection from './student/StudentShortcutsSection';

export default function StudentDashboardView() {
  const { user } = useAuth();
  const selection = useSearchParamCourseProgressSelection();

  if (!user) return null;

  return (
    <StudentLayout>
      <StudentDashboardProvider selection={selection}>
        <div className="flex flex-col gap-6 w-full h-full">
          <div className="flex flex-col gap-10 md:gap-12 min-w-0">
            <div className="flex flex-col gap-6 min-w-0">
              <StudentDashboardHeaderSection user={user} />
              <StudentContinuitySection />
              <StudentShortcutsSection />
            </div>
            <StudentCourseTrackSection />
          </div>
          <aside className="hidden lg:flex flex-col gap-6 min-w-0" />
        </div>
      </StudentDashboardProvider>
    </StudentLayout>
  );
}
